import gql from 'graphql-tag';

export default gql`
    mutation MarkAllConversationAsRead($input: MarkAllConversationReadInput) {
        markAllConversationAsRead(input: $input) {
            errors
        }
    }
`;
